<!--
  error-messagesの属性を指定できる場合はそれを使う。
  https://vuetifyjs.com/en/api/v-text-field/#props-error-messages
-->
<script setup lang="ts">
const props = defineProps<{
  messages: string[] | undefined;
}>();
</script>
<template>
  <div :class="{ 'v-input--error': messages?.length }">
    <slot />
    <div class="text-nowrap mt-1 ml-4" style="font-size: 13px" v-if="messages && messages.length">
      <div v-for="(message, index) in messages" :key="index" class="text-error">
        {{ message }}
      </div>
    </div>
  </div>
</template>
